exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FilterSwitch__switchFilterButtonMobile___34GvC {\n  padding: 10px 0;\n  background-color: #ffffff;\n  border: 1px solid #bfbfbf;\n  box-sizing: border-box;\n  border-radius: 5px;\n  padding: 8px 8px;\n  display: inline-block;\n  margin-right: 15px;\n  transition: 300ms;\n  cursor: pointer; }\n  .FilterSwitch__switchFilterButtonMobile___34GvC > img {\n    width: 20px;\n    vertical-align: middle; }\n  .FilterSwitch__switchFilterButtonMobile___34GvC > span {\n    margin-left: 8px;\n    vertical-align: middle;\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 23px;\n    color: #000000;\n    transition: 300ms; }\n  .FilterSwitch__switchFilterButtonMobile___34GvC:hover {\n    filter: brightness(0.95); }\n    .FilterSwitch__switchFilterButtonMobile___34GvC:hover span {\n      color: #ff7381; }\n", ""]);

// exports
exports.locals = {
	"switchFilterButtonMobile": "FilterSwitch__switchFilterButtonMobile___34GvC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SearchPage/FilterSwitch/FilterSwitch.scss
// module id = 4299
// module chunks = 6